import { useState } from "react";

interface PickupNoticeModalProps {
  isOpen: boolean;
  onClose: () => void;
  localStorageKey: string;
}

export default function PickupNoticeModal({
  isOpen,
  onClose,
  localStorageKey,
}: PickupNoticeModalProps) {
  const [pickupNoticePage, setPickupNoticePage] = useState(1);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4 z-50">
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-lg">
        {pickupNoticePage === 1 ? (
          <>
            <div className="text-center mb-6">
              <h2 className="text-3xl font-bold text-gray-800 mb-3 break-keep">
                '직원 확인 버튼'에 대해 알려드려요
              </h2>

              <div className="bg-primary/80 px-4 py-3 border rounded-b-lg text-white">
                <div className="flex justify-between items-center">
                  <span className="font-medium text-md">사장님 확인 코드</span>
                  <span className="font-black tracking-wider text-xl">
                    맑은 히어로
                  </span>
                </div>
                <div className="border-t border-white/50 pt-3 mt-3">
                  <div className="text-center">
                    <div className="flex flex-col items-center">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={false}
                        />
                        <div
                          className={`w-[138px] h-16 rounded-full shadow-inner transition-colors duration-300 bg-gray-300`}
                        ></div>
                        <div
                          className={`absolute w-12 h-12 bg-white rounded-full shadow-lg transform transition-transform duration-300 ease-in-out translate-x-[6px]`}
                        ></div>
                      </label>

                      <div className="text-white text-lg font-bold mt-2">
                        직원 확인 버튼
                      </div>

                      <div className="text-white text-md break-keep">
                        직원에게 이 화면 보여드리고 눌러달라고 하기!
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 space-y-2">
                <p className="text-gray-800 text-lg leading-tight break-keep">
                  이제 손님이 매장에 픽업을 하러 왔을 때 손님이 위 화면을
                  보여주면, <span className="font-bold">버튼을 눌러주세요</span>
                  .
                </p>
                <p className="text-gray-800 text-lg leading-tight break-keep">
                  손님이 <span className="font-bold">픽업을 완료</span>
                  했다는 뜻이에요.
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <button
                className="bg-blue-500 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-blue-600 transition-colors w-full"
                onClick={() => setPickupNoticePage(2)}
              >
                다음
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="text-center mb-6">
              <h2 className="text-3xl font-bold text-gray-800 mb-3 break-keep">
                픽업 완료 체크를 하면?
              </h2>

              <div className="bg-primary/80 px-4 py-3 border rounded-b-lg text-white">
                <div className="flex justify-between items-center">
                  <span className="font-medium text-md">사장님 확인 코드</span>
                  <span className="font-black tracking-wider text-xl">
                    맑은 히어로
                  </span>
                </div>
                <div className="border-t border-white/50 pt-3 mt-3">
                  <div className="text-center">
                    <div className="flex flex-col items-center">
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={false}
                        />
                        <div
                          className={`w-[138px] h-16 rounded-full shadow-inner transition-colors duration-300 bg-green-500`}
                        ></div>
                        <div
                          className={`absolute w-12 h-12 bg-white rounded-full shadow-lg transform transition-transform duration-300 ease-in-out translate-x-[82px]`}
                        ></div>
                      </label>

                      <div className="text-white text-lg font-bold mt-2">
                        직원 확인 버튼
                      </div>

                      <div className="text-white text-md break-keep">
                        직원에게 이 화면 보여드리고 눌러달라고 하기!
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-left inset-x-4 top-6 z-50 rounded-2xl bg-white border border-gray-200 px-4 py-4 space-y-2 mt-6">
                <div className="text-base font-semibold">
                  실시간 마히팩 전달 완료 ✅
                </div>
                <div className="text-gray-800 text-base break-keep">
                  "픽업 완료"로 정상 처리되었어요.
                </div>
                <div className="text-gray-800 text-base break-keep">
                  확인용 주문 코드:{" "}
                  <span className="font-medium">활기찬 히어로</span>
                  <br />
                  손님 연락처:{" "}
                  <span className="font-medium">010-****-1111</span>
                </div>
              </div>

              <div className="mt-6 space-y-2">
                <p className="text-gray-800 text-lg leading-tight break-keep">
                  사장님에게 위처럼 <span className="font-bold">알림</span>이
                  갈거에요.
                </p>
                <p className="text-gray-800 text-lg leading-tight break-keep font-bold">
                  이제 어느 손님이 픽업을 완료했는지 보다 쉽게 확인할 수 있어요!
                  😊
                </p>
              </div>
            </div>

            <div className="flex justify-center gap-4 w-full">
              <button
                className="bg-blue-500 text-white px-6 py-3 rounded-lg text-lg font-medium hover:bg-blue-600 transition-colors w-1/2"
                onClick={() => {
                  localStorage.setItem(localStorageKey, "true");
                  onClose();
                }}
              >
                다시보지 않기
              </button>
              <button
                className="bg-gray-200 text-gray-700 px-6 py-3 rounded-lg text-lg font-medium hover:bg-gray-200 transition-colors w-1/2"
                onClick={() => {
                  onClose();
                }}
              >
                닫기
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
